import React, { memo, useState, useEffect } from "react";

import loadFullMockApi from "components/FullTest/ApiCalls.js";
import ChromeCheck from "components/FullTest/ChromeCheck.jsx";
import ResourceCheck from "components/FullTest/ResourceCheck.jsx";
import Mock from "components/FullTest/Mock.jsx";
import TestResume from "components/FullTest/MockOperations/TestResume";
import TestStart from "components/FullTest/MockOperations/TestStart";
import TestFinished from "components/FullTest/MockOperations/TestFinished";

const NO_SCREEN = 0;

const FullTest = memo(function FullTest(props) {
  const [step, setStep] = useState(NO_SCREEN);
  const [mockData, setMockData] = useState(null);

  useEffect(() => {
    fetchMockDetails();

    // minimize sidebar.
    document.body.classList.toggle("sidebar-mini");

    // prevent context menu.
    document.addEventListener("contextmenu", function (e) {
      e.preventDefault();
    });
  }, []);

  const fetchMockDetails = async () => {
    const { id, pending, history } = props.match.params;
    // console.log("id and pending", id, pending);
    // console.log("fetch mock details");
    const res = await loadFullMockApi(id, pending, history);
    setMockData(res);

    if (parseInt(pending) === 0 && res.resume === true) {
      setStep(4); // resume
    } else if (parseInt(pending) === 1 && !res.resume) {
      setStep(5); // start test
    } else if (res.complete) {
      setStep(6);
    } else {
      if (parseInt(pending) === 1 && step >= 1) {
        setStep(3);
      } else {
        setStep(1);
      }
    }
  };

  const renderElement = () => {
    const { pending } = props.match.params;
    console.log(props.match.params.id, "mock id");
    let element = "";

    switch (step) {
      case 1:
        element = <ChromeCheck setStep={setStep} />;
        break;
      case 2:
        element = <ResourceCheck setStep={setStep} />;
        break;
      case 3:
        element = (
          <Mock
            setStep={setStep}
            params={props.match.params}
            mockData={mockData}
            defaultCheckPoint={parseInt(pending) === 1 ? 2 : 1}
          />
        );
        break;
      case 4:
        element = <TestResume mockId={props.match.params.id} />;
        break;
      case 5:
        element = <TestStart mockId={props.match.params.id} />;
        break;
      case 6:
        element = <TestFinished />;
        break;
      default:
      // do nothing.
    }

    return element;
  };

  return renderElement();
});

export default FullTest;
